import React from "react";
import Slider from "react-slick";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t } = useTranslation("hero"); // Use 'hero' namespace

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 20000,
    fade: true,
    arrows: false,
  };

  const slides = [
    {
      video: "/assets/video/Video_2.mp4",
      title: t("hero.title1"),
      subtitle: t("hero.subtitle1"),
    },
    {
      video: "/assets/video/heroBanner-video.mp4",
      title: t("hero.title2"),
      subtitle: t("hero.subtitle2"),
    },
  ];

  return (
    <>
      <Helmet>
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />
      </Helmet>

      <section className="relative h-screen overflow-hidden bg-primary-color text-white mb-8">
        <Slider {...settings} className="h-full">
          {slides.map((slide, index) => (
            <div
              key={index}
              className="relative h-screen w-screen flex items-center justify-center overflow-hidden"
            >
              {/* Video Background */}
              <video
                className="absolute inset-0 w-full h-full object-cover"
                src={slide.video}
                autoPlay
                muted
                loop
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-black opacity-50"></div>
              {/* Text Content */}
              <div className="absolute inset-x-0 bottom-0 z-10 text-center p-4 md:mb-10 mb-4">
                <h1 className="text-3xl md:text-5xl font-bold mb-2 md:mb-4">
                  {slide.title}
                </h1>
                <p className="text-sm md:text-lg">{slide.subtitle}</p>
              </div>
            </div>
          ))}
        </Slider>
      </section>
    </>
  );
};

export default Hero;
